import { useAtomValue } from 'jotai';

import { GetLeadByExternalId200 } from '../../../../../services/marketplace/generated/kubb/models/GetLeadByExternalId';
import { capitalizeWords, replaceUnderscores } from '../../../../../utils/strings';
import { devLeadStatusAtom, devLienholderSlugAtom } from '../../devToolbarAtoms';

const useDevLeadOverrides = (
  lead: GetLeadByExternalId200 | undefined,
): GetLeadByExternalId200 | undefined => {
  const devLeadStatus = useAtomValue(devLeadStatusAtom);
  const devLienholderSlug = useAtomValue(devLienholderSlugAtom);
  if (!lead || (!devLeadStatus && !devLienholderSlug)) return lead;
  return {
    ...lead,
    status: devLeadStatus || lead.status,
    lienholderSlug: devLienholderSlug || lead.lienholderSlug,
    // Readable stand-in only; there is no COM-side slug-to-name map (API lienholderName is the source).
    lienholderName: devLienholderSlug
      ? capitalizeWords(replaceUnderscores(devLienholderSlug))
      : lead.lienholderName,
  };
};

export default useDevLeadOverrides;
